export default "query {\n  npsFeedbackCategories\n}\n"